import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { storageKeys } from 'src/app/share/configs';
import { WindowService } from '../local/window.service';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root',
})
export class CheckoutGuard implements CanActivate {
  length!: number;
  cartSub!: Subscription;
  constructor(
    private winServe: WindowService,
    private router: Router,
    private configService: ConfigService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const externalId = route.queryParams['external_id'];
    const sParam = route.queryParams['s'];

    // If 's' parameter is provided, set the API base URL from config
    if (sParam) {
      try {
        this.configService.setExternalOrderApiBaseUrlFromParam(sParam);
      } catch (error) {
        console.error('Failed to set external order API URL:', error);
      }
    }

    // Allow external orders to pass through
    // Component will handle API call and redirect on failure
    if (externalId) {
      return true;
    }

    if (!this.winServe.getLocalStorage(storageKeys.auth)) {
      this.router.navigate(['sign-in']);
      return false;
    }

    return true;
  }
}
